define.alias("shared/components/shared/social/refresh-profile/pinterest", "settings/components/shared/social/refresh-profile/pinterest");